import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { ForgeCheckbox, ForgeOpenIcon } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';
import { Key } from 'common/types/keyboard/key';
import { SoQLType } from 'common/types/soql';
import { getParameterHumanText } from '../lib/Filters';
import { ParameterItemContext } from './ParameterItemContext';

export const ParameterControl = ({ onUpdate }: { onUpdate: (parameterOverrideValue: string) => void }) => {
  const { parameter, clientContextVariables, editMode, disabled, setOpen, open, toggleRef } =
    useContext(ParameterItemContext)!;

  const toggle = () => setOpen((prev) => !prev);

  const onKeyDownControl = (event: React.KeyboardEvent) => {
    if (!disabled && event.key === Key.Space) {
      event.stopPropagation();
      event.preventDefault();
    }
  };

  const onKeyUpControl = (event: React.KeyboardEvent) => {
    if (!disabled && [Key.Enter, Key.Space].includes(event.key as Key)) {
      event.stopPropagation();
      event.preventDefault();
      toggle();
    }
  };

  const paramText = useMemo(
    () => getParameterHumanText(parameter, clientContextVariables),
    [clientContextVariables, parameter],
  );

  if (parameter.dataType === SoQLType.SoQLBooleanT) {
    return (
      <div className={editMode ? 'filter-control-toggle boolean-parameter' : ''}>
        <ForgeCheckbox
          dense
          id={`parameter-${parameter.paramIds[0].name}-checkbox`}
          checked={parameter.overrideValue === 'true' ? true : false}
          onChange={(e: any) => onUpdate(e.target.checked.toString())}
        >
          {paramText}
        </ForgeCheckbox>
      </div>
    );
  }

  return (
    <div
      className={classNames('filter-control-toggle btn-default', {
        active: open,
        disabled,
      })}
      aria-label={`${I18n.t('shared.components.filter_bar.parameter')} ${parameter.displayName}`}
      tabIndex={0}
      ref={toggleRef}
      role={!disabled ? 'button' : undefined}
      onClick={() => !disabled && toggle()}
      onKeyDown={onKeyDownControl}
      onKeyUp={onKeyUpControl}
    >
      {paramText}
      <span className="arrow-down-icon">
        <ForgeOpenIcon aria-hidden={true} />
      </span>
    </div>
  );
};
